import * as React from "react"
import { type LayoutComponent } from "@digits-graphql/frontend/graphql-bearer"
import styled from "styled-components"
import { ComponentActionsButtons } from "src/frontend/components/Shared/Layout/Components/Controls/ComponentActionsButtons"
import { type ComponentSize } from "src/frontend/components/Shared/Layout/ComponentSize"

/*
  STYLES
*/

const ComponentControls = styled.div`
  position: relative;
`

/*
  INTERFACES
*/

interface ComponentControlsProps {
  className?: string
  component: LayoutComponent
  componentSize: ComponentSize
  isDragging?: boolean
  isEditing?: boolean
  onDeleteComponent?: (cId: string) => void
}

/*
  COMPONENTS
*/

export const ComponentActions: React.FC<React.PropsWithChildren<ComponentControlsProps>> = ({
  children,
  className,
  component,
  componentSize,
  isEditing,
  isDragging,
  onDeleteComponent,
}) => (
  <ComponentControls data-context-id={component.componentId}>
    {children}

    <ComponentActionsButtons
      className={className}
      component={component}
      componentSize={componentSize}
      onDeleteComponent={onDeleteComponent}
      isEditing={isEditing}
      isDragging={isDragging}
    />
  </ComponentControls>
)
